export const getLocationFromIframeId = id => {
  return id.split('payments-enrollment-embed-iframe-')[1];
};